/**
 * Simple regex for an email. It does not attempt to capture all the complexity of possible emails
 * but can be used for simple validation / detection. Pulled from https://ui.dev/validate-email-address-javascript
 */
export const EMAIL_REGEX = /[^\s@]+@[^\s@]+\.[^\s@]+/;

/**
 * Regex for an http url. It can be used for simple validation / detection.
 * Pulled from https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
 */
export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

/**
 * Simple regex for a phone number. It does not attempt to capture all the complexity of possible numbers
 * but can be used for simple validation / detection.
 */
export const PHONE_REGEX =
  /(?:\+?1[\s-.]?)?\(?[1-9][0-9]{2}\)?\s?[-.]?\s?[0-9]{3}\s?[-.]?\s?[0-9]{4}/;
